import {
    faClipboardList,
    faEdit,
    faEnvelope,
    faEye,
    faHome,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { useUserInfor } from "../../../../Context/User";
import { ObterFormularioProdutoController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IEmpreendimento } from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { ACESSOS } from "../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../Validations/UsuarioTela";
import VisualizarFormularioProduto from "../FormulariosProduto/VisualizarFormulario";
import RespondeFormularioProduto from "../FormulariosProduto/ResponderFormularioProduto";

interface IProdutoDaGestaoProps {
    produto: IEmpreendimento;
    updateList: () => void;
}

export default function ProdutoDaGestao(props: IProdutoDaGestaoProps) {
    const { UserInfor } = useUserInfor();
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const location = useLocation();
    const { value: obterFormularioProduto } = useAsyncEffect(
        () =>
            ObterFormularioProdutoController(
                props.produto?.ID_EMPREENDIMENTO,
                true
            ),
        []
    );
    return (
        <div className="w-100 card card-custom p-4">
            <div>
                <h4>
                    <FontAwesomeIcon icon={faHome} className="text-info mr-5" />
                    {props.produto.DS_EMPREENDIMENTO}
                </h4>
            </div>
            <hr />

            <div className="Button-Tools">
                {(obterFormularioProduto?.PERGUNTAS?.find(
                    (pergunta) => pergunta.RESPOSTA_ESCOLHIDA
                )?.RESPOSTA_ESCOLHIDA?.ID_RESPOSTA_FORMULARIO_PRODUTO ?? 0) >
                0 ? (
                    <>
                        <button
                            className="btn btn-outline-info font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: `Visualizar Formulário`,
                                    IconHeader: faEye,
                                    Component: () => (
                                        <VisualizarFormularioProduto
                                            setShow={setShow}
                                            ID_EMPREENDIMENTO={
                                                props.produto.ID_EMPREENDIMENTO
                                            }
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} size="lg" />
                            Visualizar Formulário
                        </button>
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: `Refazer Formulário`,
                                    IconHeader: faClipboardList,
                                    Component: () => (
                                        <RespondeFormularioProduto
                                            setShow={setShow}
                                            updateList={props.updateList}
                                            ID_EMPREENDIMENTO={
                                                props.produto.ID_EMPREENDIMENTO
                                            }
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faClipboardList} size="lg" />
                            Refazer Formulário
                        </button>
                    </>
                ) : (
                    obterFormularioProduto && (
                        <button
                            className="btn btn-outline-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: `Responder Formulário`,
                                    IconHeader: faEye,
                                    Component: () => (
                                        <RespondeFormularioProduto
                                            setShow={setShow}
                                            updateList={props.updateList}
                                            ID_EMPREENDIMENTO={
                                                props.produto.ID_EMPREENDIMENTO
                                            }
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} size="lg" />
                            Preencher Formulário
                        </button>
                    )
                )}
                {ACESSOS.GERAL.TELAS.FORMULARIOS_PRODUTOS.DS_PATH ? (
                    <>
                        {mostrarNavDeTela(
                            ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES
                                .ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <div className="flex-grow-1 d-flex justify-content-end flex-wrap mr-3">
                                <Link
                                    to={ACESSOS.VENDAS.TELAS.GESTAO_CONFIG_ENVELOPES.DS_LINK(
                                        props.produto.ID_EMPREENDIMENTO
                                    )}
                                    className="btn btn-light-info d-flex g-2 align-items-center"
                                >
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    Configuração de Envelopes
                                </Link>
                            </div>
                        )}

                        <Link
                            to={`${location.pathname}/EditarProduto/${props.produto.ID_EMPREENDIMENTO}`}
                            className="btn btn-outline-primary font-weight-bold mr-2"
                        >
                            <FontAwesomeIcon icon={faEdit} size="lg" /> Editar
                        </Link>
                    </>
                ) : null}
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
